import { termsData } from './data';

class TermsService {
  getTerm(type: keyof typeof termsData) {
    return termsData[type];
  }
}

export const termsService = new TermsService();
